module.exports = __webpack_public_path__ + "img/rvo-logo.91454a58.png";